import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    value;
    valType;
    curTimes = ['timeObj'];
    ismoving = false;
    startX = 0;
    startY = 0;
    endX = 0;
    endY = 0;
    tablePosition = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    };
    marker = document.createElement('div');
    selected = [];
    get selectTimes() {
        const list = [];
        const results = [];
        this.selected.forEach((item, index) => {
            if (item) {
                const val = this.getPopoverTitle(Math.floor(index / 48), index % 48, true);
                list.push(val);
            }
        });
        list.forEach((item) => {
            if (results.filter((o) => o.week === item[0]).length === 0) {
                results.push({ week: item[0], times: [], raws: [] });
            }
            const index = results.findIndex((o) => o.week === item[0]);
            results[index].raws.push({
                from: `${item[1]}:${item[2]}`,
                to: `${item[3]}:${item[4]}`,
            });
        });
        results.forEach((item, index) => {
            for (let i = 0; i < item.raws.length; i++) {
                if (item.times.length === 0) {
                    item.times.push({ from: item.raws[i].from, to: item.raws[i].to });
                }
                else if (item.raws[i].from === item.times[item.times.length - 1].to) {
                    item.times[item.times.length - 1].to = item.raws[i].to;
                }
                else {
                    item.times.push({ from: item.raws[i].from, to: item.raws[i].to });
                }
            }
        });
        return results;
    }
    valueChange() {
        if (this.value) {
            const num = 48 * 1;
            this.selected = (this.value || '')
                .split('')
                .map((o) => (Number.parseInt(o) === 1 ? 1 : 0))
                .slice(0, num);
            while (this.selected.length < num) {
                this.selected.push(0);
            }
        }
        this.handleChange();
    }
    getActiveStyle(tindex, index) {
        return this.selected[tindex + index * 48] === 1;
    }
    getDataIndex(tindex, index) {
        return tindex + index * 48;
    }
    mounted() {
        this.marker.style.background = colors.vaBcgBlue;
        this.marker.style.position = 'fixed';
        this.marker.style.zIndex = '9999';
        this.marker.style.top = '0';
        this.$refs['time-select-box'].addEventListener('mousedown', (e) => {
            this.handleMouseDown(e);
        });
    }
    handleClick(tindex, index) {
        const curIdx = tindex + index * 48;
        this.$set(this.selected, curIdx, this.selected[curIdx] === 1 ? 0 : 1);
        this.handleChange();
    }
    handleMouseDown(e) {
        this.ismoving = true;
        this.startX = e.x;
        this.startY = e.y;
        this.endX = e.x;
        this.endY = e.y;
        this.marker.style.width = '0';
        this.marker.style.height = '0';
        this.marker.style.top = `${e.x}px`;
        this.marker.style.left = `${e.y}px`;
        document.body.appendChild(this.marker);
        const rects = this.$refs['time-select-box'].getClientRects()[0];
        this.tablePosition.top = rects.top;
        this.tablePosition.left = rects.left;
        this.tablePosition.right = rects.right;
        this.tablePosition.bottom = rects.bottom;
        this.$refs['time-select-box'].__handleMouseUp__ = (e) => {
            this.handleMouseUp(e);
        };
        this.$refs['time-select-box'].__handleMouseMove__ = (e) => {
            this.handleMouseMove(e);
        };
        document.body.addEventListener('mouseup', this.$refs['time-select-box'].__handleMouseUp__);
        document.body.addEventListener('mousemove', this.$refs['time-select-box'].__handleMouseMove__);
    }
    handleMouseUp(e) {
        this.ismoving = false;
        try {
            this.marker?.parentNode?.removeChild(this.marker);
            document.body.removeEventListener('mouseup', this.$refs['time-select-box'].__handleMouseUp__);
            document.body.removeEventListener('mousemove', this.$refs['time-select-box'].__handleMouseMove__);
            this.handleDragSelect();
        }
        catch (err) {
            // todo
        }
    }
    handleMouseMove(e) {
        if (!this.ismoving) {
            return false;
        }
        this.endX = e.x;
        this.endY = e.y;
        const isoverflow = e.x <= this.tablePosition.left ||
            e.x >= this.tablePosition.right ||
            e.y <= this.tablePosition.top ||
            e.y >= this.tablePosition.bottom;
        if (isoverflow) {
            this.handleMouseUp(e);
            return false;
        }
        const width = Math.abs(this.startX - this.endX);
        const height = Math.abs(this.startY - this.endY);
        this.marker.style.width = `${width}px`;
        this.marker.style.height = `${height}px`;
        if (this.startX < this.endX) {
            this.marker.style.left = `${this.startX}px`;
        }
        else {
            this.marker.style.left = `${this.endX}px`;
        }
        if (this.startY < this.endY) {
            this.marker.style.top = `${this.startY}px`;
        }
        else {
            this.marker.style.top = `${this.endY}px`;
        }
    }
    handleDragSelect() {
        const startX = Math.min(this.startX, this.endX);
        const endX = Math.max(this.startX, this.endX);
        const startY = Math.min(this.startY, this.endY);
        const endY = Math.max(this.startY, this.endY);
        const shouldClickIndex = [];
        this.$refs['time-select-box'].querySelectorAll('.time').forEach((node, index) => {
            const rects = node.getClientRects()[0];
            // 左上角是否进入
            const ltIsCover = rects.right < endX && rects.bottom < endY && rects.right > startX && rects.bottom > startY;
            // 右下角是否进入
            const rbpIsCover = rects.left < endX && rects.top < endY && rects.left > startX && rects.top > startY;
            // 右上角是否进入
            const rtIsCover = rects.left < endX && rects.bottom < endY && rects.left > startX && rects.bottom > startY;
            // 左下角是否进入
            const lbIsCover = rects.right < endX && rects.top > startY && rects.right > startX && rects.top < endY;
            // 左边是否交叉
            const leftIsCover = rects.left > startX && rects.left < endX && rects.top < startY && rects.bottom > endY;
            // 右边是否交叉
            const rightIsCover = rects.right > startX && rects.right < endX && rects.top < startY && rects.bottom > endY;
            // 上边是否交叉
            const topIsCover = rects.top > startY && rects.top < endY && rects.left < startX && rects.right > endX;
            // 下边是否交叉
            const bottomIsCover = rects.bottom > startY && rects.bottom < endY && rects.left < startX && rects.right > endX;
            const isCover = ltIsCover || rbpIsCover || rtIsCover || lbIsCover || leftIsCover || rightIsCover || topIsCover || bottomIsCover;
            if (isCover) {
                shouldClickIndex.push(index);
            }
        });
        shouldClickIndex.forEach((item) => {
            this.$set(this.selected, item, this.selected[item] === 1 ? 0 : 1);
        });
        this.handleChange();
    }
    handleChange() {
        this.$emit('change', this.selectTimes, this.valType);
    }
    getPopoverTitle(index, tindex, isarr) {
        const y = tindex / 2;
        let hour1 = Number.parseInt(String(y), 10);
        let hour2 = hour1;
        let ext1 = '';
        let ext2 = '';
        if (hour1 === tindex / 2) {
            ext1 = '00';
            ext2 = '30';
        }
        else {
            hour2 = hour2 + 1;
            ext1 = '30';
            ext2 = '00';
        }
        const curHour1 = hour1 < 10 ? '0' + String(hour1) : '' + String(hour1);
        const curHour2 = hour2 < 10 ? '0' + String(hour2) : '' + String(hour2);
        if (isarr) {
            return [this.curTimes[index], curHour1, ext1, curHour2, ext2];
        }
        else {
            return [];
        }
        // else {
        //   return `${this.curTimes[index]}  ${curHour1}:${ext1} - ${curHour2}:${ext2}`;
        // }
    }
};
__decorate([
    Prop({ default: '' })
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: '' })
], default_1.prototype, "valType", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "valueChange", null);
default_1 = __decorate([
    Component({
        components: {},
        i18n: {},
    })
], default_1);
export default default_1;
